"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _gift = require("../../Shapes/gift.shape");

var _LatestGift = _interopRequireDefault(require("../LatestGift/LatestGift"));

var _DiscardGiftConfirmation = _interopRequireDefault(require("../../CreateGift/components/DiscardGiftConfirmation/DiscardGiftConfirmation"));

var _gift2 = require("../../CreateGift/store/gift/gift.actions");

var _GiftStatisticWrapper = _interopRequireDefault(require("./GiftStatisticWrapper"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    divider: {
      color: '#eceae7',
      width: '100%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    sendButton: {
      marginTop: theme.spacing(1),
      color: theme.palette.primary.main
    },
    icon: {
      marginRight: theme.spacing(2)
    }
  };
});

var GiftStatistic = function GiftStatistic(_ref) {
  var created = _ref.created,
      sent = _ref.sent,
      accepted = _ref.accepted,
      contact = _ref.contact,
      meetings = _ref.meetings,
      latestGift = _ref.latestGift,
      currentGift = _ref.currentGift,
      disableCreateGift = _ref.disableCreateGift,
      handleGiftViewHistory = _ref.handleGiftViewHistory,
      handleGiftCreate = _ref.handleGiftCreate;
  var dispatch = (0, _reactRedux.useDispatch)();
  var classes = useStyles();
  var hasGifts = created > 0;
  var hasLatestGift = !!latestGift;
  var hasProduct = hasLatestGift && latestGift.product;
  var detailButtonName = hasProduct ? 'View detailed gift history' : 'View gifts history';

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      discardConfirmationGiftId = _useState2[0],
      setDiscardConfirmationGiftId = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    mt: 1,
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2
  }, /*#__PURE__*/_react.default.createElement(_GiftStatisticWrapper.default, {
    title: "created",
    value: created
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2
  }, /*#__PURE__*/_react.default.createElement(_GiftStatisticWrapper.default, {
    title: "sent",
    value: sent
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    mt: 1,
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2
  }, /*#__PURE__*/_react.default.createElement(_GiftStatisticWrapper.default, {
    title: "accepted",
    value: accepted
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2
  }, /*#__PURE__*/_react.default.createElement(_GiftStatisticWrapper.default, {
    title: "meetings",
    value: meetings
  }))), /*#__PURE__*/_react.default.createElement(_LatestGift.default, {
    contact: contact,
    onCancelGift: function onCancelGift(id) {
      return setDiscardConfirmationGiftId(id);
    },
    latestGift: latestGift,
    currentGift: currentGift
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row"
  }, hasGifts ? /*#__PURE__*/_react.default.createElement(_ui.LinkButton, {
    className: "Body-Regular-Left-Link-Bold",
    onClick: handleGiftViewHistory
  }, detailButtonName) : /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: classes.sendButton,
    fullWidth: true,
    variant: "contained",
    color: "secondary",
    disabled: disableCreateGift,
    onClick: handleGiftCreate
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: "gift",
    className: classes.icon
  }), "Send them their first gift!")), /*#__PURE__*/_react.default.createElement(_DiscardGiftConfirmation.default, {
    isOpen: discardConfirmationGiftId,
    recipientName: contact.fullName,
    onCancel: function onCancel() {
      setDiscardConfirmationGiftId(null);
    },
    onSubmit: function onSubmit() {
      dispatch((0, _gift2.giftDiscardRequest)(discardConfirmationGiftId));
      setDiscardConfirmationGiftId(null);
    },
    width: "415px",
    top: "0px"
  }));
};

GiftStatistic.propTypes = {
  created: _propTypes.default.number.isRequired,
  sent: _propTypes.default.number.isRequired,
  accepted: _propTypes.default.number.isRequired,
  meetings: _propTypes.default.number.isRequired,
  disableCreateGift: _propTypes.default.bool.isRequired,
  handleGiftViewHistory: _propTypes.default.func.isRequired,
  handleGiftCreate: _propTypes.default.func.isRequired,
  contact: _propTypes.default.objectOf(_propTypes.default.string).isRequired,
  latestGift: _gift.giftShape,
  currentGift: _gift.giftShape
};
GiftStatistic.defaultProps = {
  latestGift: null,
  currentGift: null
};
var _default = GiftStatistic;
exports.default = _default;